"use client"

import React from "react"
import { Box, Container, Typography, Button } from "@mui/material"
import { Home as HomeIcon } from "@mui/icons-material"
import { useRouter } from "next/navigation"

const NotFoundPage = () => {
  const router = useRouter()

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h1"
            sx={{
              mb: 2,
              fontFamily: "var(--font-display)",
            }}
          >
            404
          </Typography>

          <Typography
            variant="h4"
            sx={{
              mb: 2,
              fontFamily: "var(--font-display)",
            }}
          >
            Page non trouvée
          </Typography>

          <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
            <Button
              variant="contained"
              startIcon={<HomeIcon />}
              onClick={() => router.push("/")}
              sx={{ px: 3, py: 1 }}
            >
              Retour au site
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default NotFoundPage
